import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebConfigService {

  percentSetList: number = environment.webConfig.percentSetList;
  percenTikTokSetList: number = environment.webConfig.percenTikTokSetList;
  costPriceIndex: number = environment.webConfig.costPriceIndex;
  srpPriceIndex: number = environment.webConfig.srpPriceIndex;
  percentPriceList: number = environment.webConfig.percentPriceList;
  tiktokCostPriceIndex: number = environment.webConfig.tiktokCostPriceIndex;

  constructor(
    private http: HttpClient
  ) { }

  async load() {
    try {
      const res: any = await firstValueFrom(this.http.get(`${environment.endpoint}/web-config`));
      if (res?.success && res.data) {
        this.assign(res.data);
      }
    } catch { }
  }

  applyUpdate(data: any) {
    this.assign(data);
  }

  private assign(data: any) {
    if (typeof data.percentSetList === 'number') this.percentSetList = data.percentSetList;
    if (typeof data.percenTikTokSetList === 'number') this.percenTikTokSetList = data.percenTikTokSetList;
    if (typeof data.costPriceIndex === 'number') this.costPriceIndex = data.costPriceIndex;
    if (typeof data.srpPriceIndex === 'number') this.srpPriceIndex = data.srpPriceIndex;
    if (typeof data.percentPriceList === 'number') this.percentPriceList = data.percentPriceList;
    if (typeof data.tiktokCostPriceIndex === 'number') this.tiktokCostPriceIndex = data.tiktokCostPriceIndex;
  }
}
